import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=b6e40ca4&scoped=true"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"
import style0 from "./Solutions.vue?vue&type=style&index=0&id=b6e40ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e40ca4",
  null
  
)

export default component.exports